// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-dots>div{animation:scale 1.5s infinite}.loading-dots>div:first-child{animation-delay:.1s}.loading-dots>div:nth-child(2){animation-delay:.5s}.loading-dots>div:nth-child(3){animation-delay:.75s}@keyframes scale{0%{transform:scale(.8)}50%{transform:scale(1.2)}to{transform:scale(.8)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
